import {useCallback, useState} from "react";
import {Section} from "../grouping/Section";
import {Button, Col, Form, FormControl, FormGroup, FormLabel, Row} from "react-bootstrap";
import {SelectionList} from "../SelectionList";
import {ModalPopUp} from "../grouping/ModalPopUp";
import {ListItemButton} from "../ListItemButton";
import {FILE_EMPTY, useFileMutations} from "../../api/fileapi";
import {useForm} from "../../utilities/formutilities";
import {ModalContentContainer} from "../grouping/ModalContentContainer";
import {RESULT_EMPTY, useResult, useResultMutations, useResults} from "../../api/resultapi";
import {useResultFileMutations, useResultFiles} from "../../api/resultfileapi";
import {SelectList} from "./components/SelectList";
import {ButtonLoading} from "../ButtonLoading";
import {ConfirmToast} from "../ConfirmToast";

export function ResultsOption(props) {
    const [isLoading, setIsLoading] = useState(false);
    const {title} = props;
    const [open, setOpen] = useState(false);
    const [fileEditing, setFileEditing] = useState(undefined);
    const {results} = useResults();
    return <Section title={title}>
        <Col xs={12} className={"text-end"}>
            <Button onClick={() => setOpen(true)}>Nieuw</Button>
        </Col>
        <SelectionList>
            {results ? results.map(a => <ListItem key={a.id} onOpenChanged={setOpen}
                                                  album={a}
                                                  onFileEditingChanged={setFileEditing}></ListItem>) : ""}
        </SelectionList>
        <ModalPopUp open={open} onOpenChanged={setOpen}
                    modalContent={<FileOptionModalContent onLoadingChange={setIsLoading} isLoading={isLoading}
                                                          fileEditing={fileEditing} setFileEditing={setFileEditing}
                                                          onOpenChanged={setOpen}/>}/>

    </Section>


}

function ListItem(props) {
    const {album, onOpenChanged, icon, onFileEditingChanged} = props;

    return <Row className={"g-0 border border-black mt-1 rounded-2"}>
        <ListItemButton onClick={() => {
            onFileEditingChanged(album);
            onOpenChanged(true);
        }}>
            <Col className={"text-start"}>
                {album ? album.title : "Geen Titel"}
            </Col>
            <Col xs={"auto"} className={"text-end"}>
                {icon}
            </Col>
        </ListItemButton>
    </Row>
}

function FileOptionModalContent(props) {
    const {fileEditing, onOpenChanged, setFileEditing, isLoading, onLoadingChange} = props;

    const {createResult, editResult, editAddNewFiles, deleteResult} = useResultMutations();
    const initialObjectInintializer = useCallback(() => fileEditing ? {
        ...fileEditing,
        date: fileEditing.date ? fileEditing.date.substring(0, 10) : new Date().toISOString().substring(0, 10)
    } : {
        ...RESULT_EMPTY,
        date: new Date().toISOString().substring(0, 10)
    }, [])
    const initialFileObjectInitializer = useCallback(() => FILE_EMPTY, []);
    const {tempFileObject, onFileInputChange} = useForm(initialFileObjectInitializer);
    const {tempObject, setTempObject, setNewObject, onChange} = useForm(initialObjectInintializer)
    const {uploadFile} = useFileMutations();

    async function handleCreateSubmit(e) {
        e.preventDefault();
        const result = await createResult({...tempObject, date: tempObject.date + "T00:00:00"});
        if (result && tempFileObject.file !== "") {

            const objReturn = await uploadFile(tempFileObject);
            if (objReturn) {
                await editAddNewFiles({...result, fileId: objReturn.id})
            }

        }
        onLoadingChange(false)
        setFileEditing(undefined);
        onOpenChanged(false);
    }

    async function handleEditSubmit(e) {
        e.preventDefault();
        const result = await editResult({...tempObject, date: tempObject.date + "T00:00:00"});
        if (result) {
            if (tempFileObject.file !== "") {
                const objReturn = await uploadFile(tempFileObject);
                if (objReturn) {
                    await editAddNewFiles({...result, fileId: objReturn.id})
                }
            }
        }
        setFileEditing(undefined);
        onLoadingChange(false)
        onOpenChanged(false);
    }


    return <ModalContentContainer onOpenChanged={onOpenChanged} onEditingChanged={setFileEditing}>

        <Section title={fileEditing ? "Wijzig resultaten" : "Nieuwe resultaten"}>
            <FormGroup>
                <FormLabel>{fileEditing ? "Wijzig hier de hoofd titel" : "Hoofd titel"}</FormLabel>
                <FormControl value={tempObject ? tempObject.title : ""}
                             onChange={event => onChange(event, "title")}/>
                <FormLabel>{fileEditing ? "Wijzig omschrijving" : "Omschrijving"}</FormLabel>
                <FormControl value={tempObject ? tempObject.description : ""}
                             onChange={event => onChange(event, "description")}/>
                <FormLabel>{fileEditing ? "Wijzig datum" : "Datum "}</FormLabel>
                <FormControl type={"date"}
                             value={tempObject.date}
                             onChange={event => onChange(event, "date")}/>

            </FormGroup>
            <hr className={"mt-3"}/>
            {fileEditing ?
                <ResultFileList onOpenChange={onOpenChanged} onLoadingChange={onLoadingChange} isLoading={isLoading}
                                resultDb={fileEditing} resultId={fileEditing.id}/> : <></>}

            {fileEditing ?

                <Col xs={6}>
                    <ConfirmToast title={"Delete"} className={"mt-3 btn-danger"}
                                  message={"Wil je deze collectie verwijderen?"}
                                  executeFunction={async () => {
                                      const message = await deleteResult(fileEditing);
                                      if (message) onOpenChanged(false);
                                      setFileEditing(undefined);
                                  }}/>
                </Col> : ""}
            <Col xs={fileEditing ? 6 : 12} className={"text-end mt-3"}>
                <Button onClick={(event) => {
                    fileEditing ? handleEditSubmit(event) : handleCreateSubmit(event)
                }}>Opslaan</Button>
            </Col>

        </Section>

    </ModalContentContainer>
}

function ResultFileList(props) {

    const {resultId, onOpenChange, isLoading, onLoadingChange} = props
    const {result} = useResult(resultId)
    const [fileForm, setFileForm] = useState({
        title: "",
        date: new Date().toISOString().substring(0, 10),
        description: "",
        fileId: "",
        resultsId: result?.id,
        files: []
    })
    const {uploadFile} = useFileMutations();
    const {createResultFile, editAddNewFiles, deleteResultFile, editAddNewResult} = useResultFileMutations();

    async function handleNewResultFile() {
        const resultCreate = await createResultFile({...fileForm, date: fileForm.date + "T00:00:00"});
        const resultFileUpload = await uploadFile({file: fileForm.files})
        if (resultCreate && resultFileUpload) {
            const resultEditResultFile = await editAddNewFiles({...resultCreate, fileId: resultFileUpload.id});
            const resultFileEdited = await editAddNewResult({...resultEditResultFile, resultId: result.id})
        }
        onLoadingChange(false)

    }

    return <Section title={"Voeg hier een nieuw resultaat toe"}>

        <FormGroup>
            <FormLabel>{result ? "Titel van nieuw resultaat" : "Nieuw bestand titel"}</FormLabel>
            <FormControl value={fileForm.title}
                         onChange={(e) => setFileForm({...fileForm, title: e.target.value})}></FormControl>
            <FormLabel>Omschrijving</FormLabel>
            <FormControl value={fileForm.description}
                         onChange={e => setFileForm({...fileForm, description: e.target.value})}/>
            <FormLabel>Datum</FormLabel>
            <FormControl type={"date"} value={fileForm.date}
                         onChange={e => setFileForm({...fileForm, date: e.target.value})}/>
            <FormLabel>Selecteer een bestand voor dit resultaat</FormLabel>
            <FormControl type={"file"}
                         onChange={(e) => setFileForm({...fileForm, files: e.target.files[0]})}></FormControl>
        </FormGroup>

        <Col xs={12} className={"text-end mt-2"}>
            <ButtonLoading title={"Voeg resultaat toe"}
                           isLoading={isLoading}
                           onClick={() => {
                               onLoadingChange(true);
                               handleNewResultFile();
                           }}></ButtonLoading>
        </Col>
        {result ? result.resultFile.map(f => <ResultFileListItem key={f.id} isLoading={isLoading}
                                                                 onLoadingChange={onLoadingChange}
                                                                 onOpenChange={onOpenChange}
                                                                 onDeleteResultFile={deleteResultFile}
                                                                 file={f}/>) : "Nog geen bestanden toegevoegd!"}
    </Section>
}

function ResultFileListItem(props) {
    const {file, onDeleteResultFile, onOpenChange, isLoading, onLoadingChange} = props;

    async function handleDelete(e) {
        await onDeleteResultFile(file);
        onLoadingChange(false)

    }

    return <ListItemButton>
        <Row className={"g-0 shadow p-1 rounded-2"}>
            <Col className={"text-start"}>{file?.title}</Col>
            <Col className={"text-end"}>
                <ConfirmToast title={"Verwijder"} className={"btn-warning text-white"}
                              message={"Wil je dit resultaat verwijderen?"} executeFunction={() => handleDelete()}/>

            </Col>
        </Row>

    </ListItemButton>

}